import React, { useEffect, useState } from "react";
import axios from "axios";

const SlotList = ({ doctor, patient, slotdate, onBack }) => {
  const [slots, setSlots] = useState([]);
  const [confirmation, setConfirmation] = useState(null);

  useEffect(() => {
    axios
      .get(
        `https://nhniapp.in/webapi/spls/getSlotList.php?doctorid=${doctor.doctorid}&slotdate=${slotdate}`
      )
      .then((res) => setSlots(res.data))
      .catch(() => alert("Failed to load slots"));
  }, [doctor.doctorid, slotdate]);

  const bookSlot = (slot) => {
  axios.post(
    "https://nhniapp.in/webapi/spls/bookAppointment.php",
    {
      doctorid: doctor.doctorid,
      patphno: patient.phone,
      slotdate: slotdate,
      slotno: slot.slotno
    },
    { headers: { "Content-Type": "application/json" } }
  ).then(res => {
    if (res.data.success) {
      setConfirmation({
        slot,
        tokenno: res.data.tokenno,
        doctorfees: res.data.doctorfees,
        regfees: res.data.regfees
      });
    } else {
      alert(res.data.message);
    }
  });
};

if (confirmation) {
  return (
    <div className="container">
      <div className="card p-4 shadow text-center">
        <h4 className="text-success mb-3">
          Your Appointment Request Generated
        </h4>

        <p><b>Doctor:</b>  {doctor.title}  {doctor.doctorsname}</p>
        <p><b>Patient:</b> {patient.name}</p>
        <p><b>Date:</b> {slotdate}</p>
        <p><b>Time:</b> {confirmation.slot.slotname}</p>

        <h3 className="mt-3">
          ARN No:
          <span className="text-primary ms-2">
            {confirmation.tokenno}
          </span>
        </h3>

        <h4 className="mt-3">
          Doctor Fees:
          <span className="text-primary ms-2">
            {confirmation.doctorfees}
          </span>
        </h4>

        <h4 className="mt-3">
          Registration Fees:
          <span className="text-primary ms-2">
            {confirmation.regfees} (Valid for 15 days)
          </span>
        </h4>
        <h4 className="mt-3">
          <p>You will receive a call back from our booking desk within 2 hrs. </p>
          <p>Booking Desk is open from 9AM to 7PM</p>
        </h4>
      </div>
    </div>
  );
}


  return (
    <div className="container">

      {/* Top Panel */}
      <div className="card mb-4 p-3 shadow-sm">
        <h5 className="text-primary mb-1">
           {doctor.title}  {doctor.doctorsname}
        </h5>
        <div className="text-muted">
          {patient.name} | {patient.phone}
          {patient.email && ` | ${patient.email}`}
        </div>
        <div className="fw-bold mt-1">
          Slot Date: {slotdate}
        </div>
      </div>

      {/* Slot List Table */}
      <h6 className="mb-3">Available Slots</h6>

      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead className="table-light">
            <tr>
              <th>Slot No</th>
              <th>Slot Time</th>
              <th className="text-center">Option</th>
            </tr>
          </thead>
          <tbody>
            {slots.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center">
                  No slots available
                </td>
              </tr>
            ) : (
              slots.map((slot, index) => (
                <tr key={index}>
                  <td>{slot.slotno}</td>
                  <td>{slot.slotname}</td>
                  <td className="text-center">
                    <button className="btn btn-sm btn-success"
                    onClick={() => bookSlot(slot)}
                    >
                      Select
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <button className="btn btn-secondary mt-3" onClick={onBack}>
        ← Back
      </button>
    </div>
  );
};

export default SlotList;
